import React, { Component } from "react";
import { connect } from "react-redux";
import { noMixedBankDataComp } from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Divider } from "@material-ui/core";
import api from "../../config/api";
import { cga } from "../../helper/formatersMask";

const styles = (theme) => ({
  container: {
    justifyContent: "center",
  },
  main: {
    maxWidth: 600,
  },
  printButton: {
    margin: "20px auto",
    display: "flex",
  },
  borderItem: {
    padding: 35,
    border: "1px solid #00000033",
  },
  header: {
    display: "flex",
    justifyContent: "space-around",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  headerImg: {
    width: 100,
    height: 100,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 0 30px 0",
  },
  contentTitle: {
    fontSize: 25,
    fontWeight: 500,
  },
  contentDescription: {
    fontSize: 21,
    fontWeight: 500,
  },
  dataReportItem: {
    margin: 4,
  },
  bankItem: {
    display: "flex",
    alignItems: "center",
    margin: 2,
  },
  dot: {
    width: 5,
    height: 5,
    marginRight: 6,
    background: "#000",
    borderRadius: "50%",
  },
  divider: {
    width: "100%",
  },
});

export class ReportsNonMixedBanks extends Component {
  state = {
    banksList: [],
  };

  componentDidMount() {
    if (this.props.noMixedBankDataValue.length > 0) {
      api
        .get("Bancos/Consultar?opcao=2")
        .then((banksGroup) => {
          if (banksGroup.data.length > 0) {
            const banks = banksGroup.data.filter(
              (item) => item.PermiteDebitoAutomatico === true
            );
            this.setState({
              banksList: banks,
            });
          }
        })
        .catch((error) => {
          if (error.response.status >= 500) {
            this.setState({
              error:
                "Servidor indisponível no momento, tente novamente mais tarde",
              loading: false,
            });
          } else if (error.response.status === 404) {
            this.setState({
              error: "Item não encontrado",
              loading: false,
            });
          } else {
            this.setState({
              error: error.response.data.error_description,
              loading: false,
            });
          }
        });
    } else {
      const { from } = this.props.location.state || {
        from: { pathname: "/" },
      };
      this.props.history.push(from);
    }
  }

  render() {
    const { classes } = this.props;
    const currentPath = window.location.origin;

    return (
      <div>
        <Grid container style={{ justifyContent: "center", display: "flex" }}>
          <div class="main" style={{ maxWidth: 600 }}>
            {/* <button style={{margin: '20px auto', display: 'flex'}} className={classes.printButton} onClick={() => window.print()}>IMPRIMIR</button> */}

            <div
              style={{ padding: "35px", border: "1px solid #00000033" }}
              className={classes.borderItem}
            >
              <Grid item xs={12} sm={12} md={12} elevation={0}>
                <div
                  style={{ display: "flex", justifyContent: "space-around" }}
                  className={classes.header}
                >
                  <img
                    alt="Logo Prefeitura Pomba"
                    src={`${currentPath}/logo-prefeitura-pomba.png`}
                    style={{ width: "100px", height: "100px" }}
                    className={classes.headerImg}
                  />
                  <div>
                    <p>
                      <strong>PMS</strong> - PREFEITURA MUNICIPAL DE SALVADOR
                    </p>
                    <p>
                      <strong>SEFAZ</strong> - SECRETARIA MUNICIPAL DA FAZENDA
                    </p>
                    <p>
                      <strong>SEQ</strong> - SETOR DE QUALIDADE
                    </p>
                  </div>
                </div>
              </Grid>
              <Divider style={{}} className={classes.divider} />
              <Grid item xs={12} sm={12} md={12} elevation={0}>
                <div
                  style={{
                    display: "flex",
                    "flex-direction": "column",
                    padding: "10px 0 30px 0",
                  }}
                  className={classes.content}
                >
                  <h1
                    style={{ fontSize: "25px", fontWeight: 500 }}
                    className={classes.contentTitle}
                  >
                    CÓDIGO DE IDENTIFICAÇÃO PARA DESCADASTRAMENTO DO DÉBITO
                    AUTOMÁTICO
                  </h1>
                  {this.props.noMixedBankDataValue.map((item) => {
                    return (
                      <div>
                        <p
                          style={{ margin: 4 }}
                          className={classes.dataReportItem}
                        >
                          <strong>Receita: </strong>
                          <span>{item.Tributo.Nome}</span>
                        </p>
                        {item.Contribuinte.TipoInscricao === 3 && (
                          <p
                            style={{ margin: 4 }}
                            className={classes.dataReportItem}
                          >
                            <strong>Estabelecimento: </strong>{" "}
                            <span>
                              {item.Contribuinte.NumInscricaoFormatado}
                            </span>
                          </p>
                        )}

                        {item.Contribuinte.TipoInscricao === 4 && (
                          <p
                            style={{ margin: 4 }}
                            className={classes.dataReportItem}
                          >
                            <strong>Inscrição Mobiliária: </strong>{" "}
                            <span>
                              {item.Contribuinte.NumInscricaoFormatado}
                            </span>
                          </p>
                        )}

                        {item.Contribuinte.TipoInscricao === 5 && (
                          <p
                            style={{ margin: 4 }}
                            className={classes.dataReportItem}
                          >
                            <strong>Nº Documento Fiscal: </strong>{" "}
                            <span>
                              {item.Contribuinte.NumInscricaoFormatado}
                            </span>
                          </p>
                        )}

                        {item.Contribuinte.TipoInscricao === 6 && (
                          <p
                            style={{ margin: 4 }}
                            className={classes.dataReportItem}
                          >
                            <strong>Nº Parcelamento: </strong>{" "}
                            <span>
                              {item.Contribuinte.NumInscricaoFormatado}
                            </span>
                          </p>
                        )}

                        {item.Contribuinte.TipoInscricao !== 3 &&
                          item.Contribuinte.TipoInscricao !== 4 &&
                          item.Contribuinte.TipoInscricao !== 5 && (
                            <p
                              style={{ margin: 4 }}
                              className={classes.dataReportItem}
                            >
                              <strong>Nº Inscrição: </strong>{" "}
                              <span>
                                {cga(item.Contribuinte.NumInscricaoFormatado)}
                              </span>
                            </p>
                          )}

                        <p
                          style={{ margin: 4 }}
                          className={classes.dataReportItem}
                        >
                          <strong>Contribuinte: </strong>
                          <span>{item.Contribuinte.NumInscricao}</span>
                        </p>
                        <p
                          style={{ margin: 4 }}
                          className={classes.dataReportItem}
                        >
                          <strong>Código: </strong>{" "}
                          <span>
                            <strong>{item.IdItem}</strong>
                          </span>
                        </p>
                      </div>
                    );
                  })}
                </div>
              </Grid>

              <Divider style={{ width: "100%" }} className={classes.divider} />
              <Grid item xs={12} sm={12} md={12} elevation={0}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px 0 30px 0",
                  }}
                  className={classes.content}
                >
                  <h1
                    style={{ fontSize: 25, fontWeight: 500 }}
                    className={classes.contentTitle}
                  >
                    Observações:
                  </h1>
                  <p style={{ margin: "0 0 20px 0" }}>
                    Rede Bancária credenciada * para o serviço de Dèbito
                    Automático
                  </p>

                  {this.state.banksList.map((item) => {
                    return (
                      <p
                        style={{
                          display: "flex",
                          alignItems: "center",
                          margin: 2,
                        }}
                        className={classes.bankItem}
                      >
                        <div
                          style={{
                            width: 5,
                            height: 5,
                            marginRight: 6,
                            background: "#000",
                            borderRadius: "50%",
                          }}
                          className={classes.dot}
                        ></div>{" "}
                        {item.Descricao}
                      </p>
                    );
                  })}
                  <p style={{ margin: "40px 0 0 0" }}>
                    * Em breve outros Bancos da Rede Bancária disponibilizarão
                    pagamentos em Débito Automático.
                  </p>
                </div>
              </Grid>
            </div>
          </div>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  noMixedBankDataValue: store.cardDebitState.noMixedBankDataValue,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      noMixedBankDataComp,
    },
    dispatch
  );

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(ReportsNonMixedBanks)
);
